export default "/images/805d45c6ef2c185c3e3d84d4b3acf1ae.png";